import type { Boot } from 'portlet/config/boot';

export const resolveBootPlaceholders = <T>(config: T, boot: Boot): T =>
    JSON.parse(
        JSON.stringify(config)
            .replace(/:mockserver:/g, boot.servers.mockServer.url)
            .replace(/:backendserver:/g, boot.servers.backendServerHost.url)
            .replace(/:masterdataserver:/g, boot.servers.masterData.url)
            // sanitize. replace multiple forward slashes by a single one.
            .replace(/(\w)\/\/+/g, '$1/'),
    );

export const resolveAdditionalAttributes = <T>(
    spec: T,
    additionalAttrs: Record<string, string>,
): T => {
    const stringifiedSpec = JSON.stringify(spec);
    const replacements = Object.entries(additionalAttrs).map(([attr, value]) => [
        `:${attr}:`,
        value,
    ]);
    const replaced = replacements.reduce(
        (acc, [placeholder, replacement]) => acc.replace(new RegExp(placeholder, 'g'), replacement),
        stringifiedSpec,
    );

    return JSON.parse(replaced);
};
